module.exports = __webpack_public_path__ + "img/Asistencia_funeraria_ocupantes.b295db79.svg";